var map = {
	"./building-icon.jpg": "./src/assets/img/theme/building-icon.jpg",
	"./hadm-icon.jpg": "./src/assets/img/theme/hadm-icon.jpg",
	"./hans-icon.jpg": "./src/assets/img/theme/hans-icon.jpg",
	"./hrms-icon.jpg": "./src/assets/img/theme/hrms-icon.jpg",
	"./hucs-icon.jpg": "./src/assets/img/theme/hucs-icon.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/theme sync recursive ^\\.\\/.*\\-icon\\.jpg$";